import { isNil } from 'ramda';

export function isValidInput(min: number | undefined, max: number | undefined) {
  return !isNil(min) && !isNil(max) && min > max;
}
